export const IMAGES = {
  heroSpice: "https://images.pexels.com/photos/33654800/pexels-photo-33654800.jpeg?auto=compress&cs=tinysrgb&w=1600",
  spicesMacro: "https://images.pexels.com/photos/28411491/pexels-photo-28411491.jpeg?auto=compress&cs=tinysrgb&w=1600",
  farm: "https://images.pexels.com/photos/5602330/pexels-photo-5602330.jpeg?auto=compress&cs=tinysrgb&w=1200",
  sowing: "https://images.pexels.com/photos/18620458/pexels-photo-18620458.jpeg?auto=compress&cs=tinysrgb&w=1600",
  cargo: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg?auto=compress&cs=tinysrgb&w=1200",
  herbs: "https://images.pexels.com/photos/10126645/pexels-photo-10126645.jpeg?auto=compress&cs=tinysrgb&w=1200",
  warehouse: "https://images.pexels.com/photos/4483610/pexels-photo-4483610.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

// Moving hero slideshow — themed slides with per-slide copy & CTA
export const HERO_SLIDES = [
  {
    src: "https://live.staticflickr.com/2215/2218049541_247c474079_b.jpg",
    alt: "Indian farmlands at sunrise",
    headline: "From India's Finest Farms to the World",
    sub: "Premium herbs, spices, botanicals & natural ingredients sourced directly from trusted farmers.",
    cta: "Explore Products", href: "/products",
  },
  {
    src: "https://live.staticflickr.com/8317/8000077296_dd488137ff_b.jpg",
    alt: "Farmers harvesting fresh herbs",
    headline: "Empowering Farmers. Delivering Purity.",
    sub: "Fair partnerships with grower families across India — from the soil that raised it to the shelf that needs it.",
    cta: "Explore Our Products", href: "/products",
  },
  {
    src: "https://live.staticflickr.com/5606/15327490717_b4aa00499c_b.jpg",
    alt: "Sun-drying harvested chillies and spices",
    headline: "Every Batch Tested. Every Shipment Trusted.",
    sub: "HACCP · GMP · ISO 22000 · APEDA — international quality standards on every consignment.",
    cta: "Our Quality Process", href: "#quality",
  },
  {
    src: "https://images.pexels.com/photos/6752846/pexels-photo-6752846.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "International export shipping containers",
    headline: "Exporting Quality Across Global Markets",
    sub: "Container-scale volumes shipped to 42+ countries with complete documentation & traceability.",
    cta: "Become Our Partner", href: "#contact",
  },
  {
    src: "https://images.pexels.com/photos/28411491/pexels-photo-28411491.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "Premium finished herbal products and spices",
    headline: "Nature's Best, Delivered Worldwide",
    sub: "Retail-ready and bulk packaging crafted to your brand and your market's standards.",
    cta: "Request a Quote", href: "#contact",
  },
];

// From Soil to Shipment — sourcing journey (alternating layout)
export const STORY = [
  {
    n: "01", title: "The Farmers",
    text: "Our journey begins with experienced farmers who cultivate herbs, spices and medicinal plants using traditional knowledge and sustainable agricultural practices.",
    img: "https://live.staticflickr.com/4096/4778370968_32dbd29eef_b.jpg",
    alt: "Indian farmers cultivating herbs and medicinal plants",
  },
  {
    n: "02", title: "Careful Harvesting",
    text: "Every crop is harvested at the ideal maturity stage to preserve maximum nutritional value, aroma and medicinal properties — then naturally dried to lock in potency.",
    img: "https://live.staticflickr.com/5606/15327490717_b4aa00499c_b.jpg",
    alt: "Fresh harvesting and sun-drying of herbs and spices",
  },
  {
    n: "03", title: "Cleaning & Processing",
    text: "Products undergo careful cleaning, sorting, grading and hygienic processing in modern facilities while maintaining strict quality standards at every step.",
    img: "https://live.staticflickr.com/3839/15219467505_1bb1715cff_b.jpg",
    alt: "Modern grain cleaning and sorting facility",
  },
  {
    n: "04", title: "Quality Assurance",
    text: "Each batch is laboratory-tested for purity, safety, moisture, microbial limits and export compliance before it is ever cleared for dispatch.",
    img: "https://live.staticflickr.com/5056/5433707781_a1198c47ce_b.jpg",
    alt: "Laboratory testing and quality inspection",
  },
  {
    n: "05", title: "Global Export",
    text: "Products are packed to international export standards and delivered to customers across global markets with complete documentation and traceability.",
    img: "https://images.pexels.com/photos/30115463/pexels-photo-30115463/free-photo-of-cargo-ship-with-containers-in-shipping-port.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "Export containers, logistics and worldwide shipping",
  },
];

export const STATS = [
  { value: 42, suffix: "+", label: "Countries Served" },
  { value: 60, suffix: "+", label: "Products Exported" },
  { value: 9, suffix: "", label: "Quality Certifications" },
  { value: 15, suffix: "+", label: "Years of Excellence" },
  { value: 300, suffix: "+", label: "Global Buyers" },
];

export const WHY = [
  { t: "Direct Farm Sourcing", d: "Farm-gate procurement from certified grower networks across India." },
  { t: "Export Quality Products", d: "Grade-consistent lots meeting the world's most demanding buyers." },
  { t: "Sustainable Agriculture", d: "Rain-fed, low-input farming that protects soil, potency & planet." },
  { t: "Certified Processing", d: "HACCP & ISO 22000 controlled facilities with hygienic handling." },
  { t: "Strict Quality Control", d: "Every lot lab-tested for purity, moisture, aflatoxin & residue." },
  { t: "Worldwide Shipping", d: "FOB, CIF & DDP logistics across all major sea and air ports." },
  { t: "Custom Packaging", d: "From 25kg jute to private-label retail — your brand, our craft." },
  { t: "Competitive Pricing", d: "Vertically integrated supply chain removes middlemen margins." },
];

export const CERTS = ["FSSAI", "APEDA", "IEC", "ISO 22000", "GMP", "HACCP", "Organic", "Halal", "Kosher"];

export const MANIFESTO = [
  { n: "01", t: "Our Roots", d: "Karmaa Overseas was born from the soil of India — a nation whose spices and botanicals have shaped world trade for millennia. We carry that legacy forward with integrity." },
  { n: "02", t: "Our Network", d: "We partner directly with thousands of farmers, agronomists and cooperatives, ensuring fair value at the source and full traceability from field to freight." },
  { n: "03", t: "Our Standard", d: "Modern processing under ISO 22000 & HACCP discipline. Sortex cleaning, controlled milling, and rigorous laboratory validation on every consignment." },
  { n: "04", t: "Our Promise", d: "To connect India's agricultural excellence to discerning buyers worldwide — reliably, sustainably, and at a standard the global market can trust." },
];

export const TIMELINE = [
  { step: "Farm Selection", img: "https://images.pexels.com/photos/5602330/pexels-photo-5602330.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { step: "Raw Material Inspection", img: "https://live.staticflickr.com/3539/5755158803_8dea1ba9e4_b.jpg" },
  { step: "Cleaning", img: "https://live.staticflickr.com/3839/15219467505_1bb1715cff_b.jpg" },
  { step: "Sorting", img: "https://live.staticflickr.com/8095/29030465546_a26d3d6996_b.jpg" },
  { step: "Grinding", img: "https://live.staticflickr.com/8156/7637937542_b870fe2c5e_b.jpg" },
  { step: "Laboratory Testing", img: "https://live.staticflickr.com/5056/5433707781_a1198c47ce_b.jpg" },
  { step: "Packaging", img: "https://images.pexels.com/photos/4483610/pexels-photo-4483610.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { step: "Container Loading", img: "https://live.staticflickr.com/7032/6614272657_491e9b50ae_b.jpg" },
  { step: "Export Documentation", img: "https://live.staticflickr.com/116/264546918_5cc04e9357_b.jpg" },
  { step: "International Shipping", img: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg?auto=compress&cs=tinysrgb&w=600" },
];

export const INDUSTRIES = [
  "Food Industry", "Nutraceuticals", "Ayurveda", "Pharmaceutical", "Cosmetics",
  "Animal Feed", "Health Supplements", "Retail", "Private Label", "Bulk Manufacturing",
];

export const PACKAGING = [
  { t: "25kg PP Bags", d: "Woven polypropylene for dry granular goods." },
  { t: "50kg Jute Bags", d: "Breathable natural fibre for pulses & cereals." },
  { t: "Paper Bags", d: "Multi-wall kraft for powders & fine grinds." },
  { t: "HDPE Bags", d: "Moisture-barrier lining for humidity-sensitive lots." },
  { t: "Vacuum Packs", d: "Oxygen-free sealing for extracts & premium spices." },
  { t: "Private Label", d: "Retail-ready packaging printed to your brand." },
];

export const SUSTAINABILITY = [
  { t: "Eco-friendly Sourcing", d: "Regenerative & rain-fed cultivation partnerships." },
  { t: "Farmer Empowerment", d: "Fair pricing, training & assured buy-back programs." },
  { t: "Waste Reduction", d: "By-product upcycling and low-water processing." },
  { t: "Renewable Practices", d: "Solar-assisted drying and energy-efficient milling." },
];

export const TESTIMONIALS = [
  { q: "Karmaa's turmeric consistency is unmatched. Curcumin levels are always spot-on, batch after batch.", n: "Michael R.", r: "Procurement Head, USA Nutraceutical Brand" },
  { q: "Documentation and lead times are flawless. They understand European compliance better than most.", n: "Sofia L.", r: "Import Manager, Germany" },
  { q: "From sampling to full container, the professionalism is world-class. Our preferred India partner.", n: "Ahmed K.", r: "Distributor, UAE" },
  { q: "Their millets opened a whole new health-food line for us. Clean, graded, reliable.", n: "James T.", r: "Retail Buyer, Australia" },
];

export const FAQ = [
  { q: "What is your minimum order quantity (MOQ)?", a: "MOQ is typically 1 Metric Ton per product, though we accommodate sample orders and mixed containers for new buyers." },
  { q: "Which countries do you export to?", a: "We currently ship to 42+ countries across North America, Europe, the Middle East, Australia, Africa and Southeast Asia." },
  { q: "What packaging options are available?", a: "25kg/50kg PP, jute, HDPE and paper bags, vacuum packs, and fully custom private-label retail packaging." },
  { q: "How do payments work?", a: "We accept Letter of Credit (LC), TT advance, and negotiated terms for established buyers. Details shared per order." },
  { q: "Can I request samples before ordering?", a: "Yes. We provide pre-shipment samples with a Certificate of Analysis so you can validate quality first." },
  { q: "What are your typical lead times?", a: "Ready stock ships in 10–20 days. Custom processing or private-label orders may vary by volume." },
  { q: "What certifications do you hold?", a: "FSSAI, APEDA, IEC, ISO 22000, GMP, HACCP, Organic and Halal — with Kosher available on request." },
];

export const DESTINATIONS = [
  { name: "USA", x: 205, y: 210 }, { name: "Canada", x: 210, y: 150 },
  { name: "Germany", x: 500, y: 175 }, { name: "UK", x: 470, y: 165 },
  { name: "UAE", x: 585, y: 235 }, { name: "Saudi Arabia", x: 565, y: 240 },
  { name: "Australia", x: 800, y: 380 }, { name: "South Africa", x: 530, y: 400 },
  { name: "Singapore", x: 730, y: 300 }, { name: "Malaysia", x: 725, y: 295 },
];

export const INDIA = { x: 640, y: 255 };

export const CONTACT = {
  email: "hello@karmaaoverseas.com",
  phone: "+91 92665 33457",
  whatsapp: "919266533457",
  address: "Ghaziabad, Uttar Pradesh, India",
  hours: "Mon – Sat · 9:30 AM – 6:30 PM IST",
};

// Detailed certifications for the dedicated Certifications page
export const CERT_DETAILS = [
  { code: "FSSAI", name: "Food Safety & Standards Authority of India", desc: "National food-safety licensing ensuring every lot meets India's statutory hygiene, handling and labelling standards." },
  { code: "APEDA", name: "Agricultural & Processed Food Products Export Development Authority", desc: "Government registration authorising the export of scheduled agricultural products with full traceability." },
  { code: "IEC", name: "Import Export Code", desc: "DGFT-issued code enabling compliant cross-border trade and customs clearance from any Indian port." },
  { code: "ISO 22000", name: "Food Safety Management System", desc: "Internationally recognised framework governing hazard control across our entire processing chain." },
  { code: "GMP", name: "Good Manufacturing Practices", desc: "Documented facility, equipment and personnel hygiene protocols that guarantee consistent product quality." },
  { code: "HACCP", name: "Hazard Analysis Critical Control Points", desc: "Preventive risk-management system identifying and controlling biological, chemical and physical hazards." },
  { code: "Organic", name: "Certified Organic (NPOP / NOP)", desc: "Chemical-free cultivation and processing verified against Indian and USDA organic standards." },
  { code: "Halal", name: "Halal Certified", desc: "Compliance with Islamic dietary law for buyers across the Middle East and Southeast Asia." },
  { code: "Kosher", name: "Kosher Certified", desc: "Available on request — meeting Jewish dietary requirements for global retail and food-service buyers." },
];

// Gallery — verified Pexels/Flickr assets grouped by theme
export const GALLERY = [
  { src: "https://live.staticflickr.com/2215/2218049541_247c474079_b.jpg", alt: "Indian farmlands at sunrise", tag: "Farms" },
  { src: "https://live.staticflickr.com/4096/4778370968_32dbd29eef_b.jpg", alt: "Farmers cultivating herbs", tag: "Farmers" },
  { src: "https://live.staticflickr.com/5606/15327490717_b4aa00499c_b.jpg", alt: "Sun-drying harvested chillies", tag: "Harvest" },
  { src: "https://live.staticflickr.com/3839/15219467505_1bb1715cff_b.jpg", alt: "Grain cleaning and sorting facility", tag: "Processing" },
  { src: "https://live.staticflickr.com/5056/5433707781_a1198c47ce_b.jpg", alt: "Laboratory quality testing", tag: "Quality" },
  { src: "https://images.pexels.com/photos/28411491/pexels-photo-28411491.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "Premium spices and powders", tag: "Products" },
  { src: "https://images.pexels.com/photos/33654800/pexels-photo-33654800.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "Assorted Indian spices", tag: "Products" },
  { src: "https://images.pexels.com/photos/4483610/pexels-photo-4483610.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "Export packaging warehouse", tag: "Packaging" },
  { src: "https://live.staticflickr.com/7032/6614272657_491e9b50ae_b.jpg", alt: "Container loading for export", tag: "Logistics" },
  { src: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "International shipping vessel", tag: "Logistics" },
  { src: "https://images.pexels.com/photos/5602330/pexels-photo-5602330.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "Green farm fields", tag: "Farms" },
  { src: "https://images.pexels.com/photos/6752846/pexels-photo-6752846.jpeg?auto=compress&cs=tinysrgb&w=1200", alt: "Export shipping containers", tag: "Logistics" },
];
